import { render } from "./DataInput.vue?vue&type=template&id=3d42320d&scoped=true&ts=true"
import script from "./DataInput.vue?vue&type=script&lang=ts"
export * from "./DataInput.vue?vue&type=script&lang=ts"

import "./DataInput.vue?vue&type=style&index=0&id=3d42320d&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d42320d"]])

export default __exports__